import { Scale } from "lucide-react";
import { fmtTL, fmtDate } from "../../lib/format";

const signCls = (v) => (v < 0 ? "text-red-700" : v > 0 ? "text-emerald-700" : "text-slate-700");
export const fmtSigned = (v) => `${v > 0 ? "+" : ""}${fmtTL(v)}`;

// Hakediş raporu: DÜZELTME FARKLARI bölümü (düzeltme şubelerine girilen ± kayıtlar; toplama dahil)
export default function CorrectionsBlock({ corrections, totalKey, showSub = false, testid = "claim-corrections" }) {
  if (!corrections?.rows?.length) return null;
  const heads = ["Tarih", "Bölge", "Şube", "Hizmet", "Açıklama", ...(showSub ? ["Taşeron"] : []), "Tutar"];
  return (
    <div className="bg-white border-2 border-violet-300 rounded-lg overflow-hidden" data-testid={testid}>
      <div className="px-5 py-3 border-b border-violet-200 bg-violet-50 flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="text-sm font-bold text-slate-900 uppercase tracking-wide inline-flex items-center gap-2"><Scale className="w-4 h-4 text-violet-700" /> Düzeltme Farkları</div>
          <div className="text-xs text-slate-500">Bölgelerin DÜZELTME FARKLARI şubelerine girilen eksik (−) / fazla (+) tutarlar — yukarıdaki tabloda ait olduğu proje / bölge / ana hizmet satırına ve hizmet ara toplamına dahildir; özet tablolarda ayrı satırdır.</div>
        </div>
        <div className={`text-sm font-extrabold ${signCls(corrections.total)}`} data-testid={`${testid}-total`}>{fmtSigned(corrections.total)}</div>
      </div>
      <table className="w-full tbl">
        <thead className="bg-white"><tr>{heads.map((h, i) => <th key={h} className={`px-4 py-2 text-xs uppercase tracking-wider text-slate-500 font-semibold ${i === heads.length - 1 ? "text-right" : "text-left"}`}>{h}</th>)}</tr></thead>
        <tbody>
          {corrections.rows.map((r) => (
            <tr key={r.id} className="border-t border-slate-100" data-testid={`${testid}-row-${r.id}`}>
              <td className="px-4 py-2 text-xs">{fmtDate(r.entry_date)}</td>
              <td className="px-4 py-2 text-xs">{r.region_name || "—"}</td>
              <td className="px-4 py-2 text-xs font-semibold">{r.location_name}</td>
              <td className="px-4 py-2 text-xs">{r.service_name}</td>
              <td className="px-4 py-2 text-xs text-slate-700">{r.description || "—"}</td>
              {showSub && <td className="px-4 py-2 text-xs">{r.subcontractor_name || "—"}</td>}
              <td className={`numeric-cell px-4 py-2 text-xs font-bold ${signCls(r[totalKey])}`}>{fmtSigned(r[totalKey] || 0)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
